// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Form from "../components/Form.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";

function fromString(x) {
  switch (x) {
    case "female" :
        return /* FEMALE */0;
    case "male" :
        return /* MALE */1;
    default:
      return /* OTHER */2;
  }
}

function toString(x) {
  switch (x) {
    case /* FEMALE */0 :
        return "female";
    case /* MALE */1 :
        return "male";
    case /* OTHER */2 :
        return "other";
    
  }
}

function ProfileGender(Props) {
  var gender = Props.gender;
  var onChange = Props.onChange;
  var display = Props.display;
  return React.createElement(React.Fragment, undefined, React.createElement(Form.Label.make, {
                  text: "เพศ"
                }), React.createElement("div", {
                  className: "flex justify-between px-1"
                }, React.createElement(Form.Radio.make, {
                      checked: gender === /* FEMALE */0,
                      label: Curry._1(display, /* FEMALE */0),
                      onClick: (function (param) {
                          return Curry._1(onChange, /* FEMALE */0);
                        })
                    }), React.createElement(Form.Radio.make, {
                      checked: gender === /* MALE */1,
                      label: Curry._1(display, /* MALE */1),
                      onClick: (function (param) {
                          return Curry._1(onChange, /* MALE */1);
                        })
                    }), React.createElement(Form.Radio.make, {
                      checked: gender === /* OTHER */2,
                      label: Curry._1(display, /* OTHER */2),
                      onClick: (function (param) {
                          return Curry._1(onChange, /* OTHER */2);
                        })
                    })));
}

var make = ProfileGender;

export {
  fromString ,
  toString ,
  make ,
  
}
/* Form Not a pure module */
